export default __webpack_public_path__ + "static/media/insta.edb90ecc.png";